"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRoles = exports.hasAdminRole = exports["default"] = void 0;
var _Roles = _interopRequireDefault(require("./constants/Roles"));
var hasAdminRole = exports.hasAdminRole = function hasAdminRole(permissions) {
  return hasRoles([_Roles["default"].admin.value], permissions);
};
var hasRoles = exports.hasRoles = function hasRoles(roles, permissions) {
  /**
   * If one of users permissions has a role inside of the
   * roles property then return true
   */
  return !permissions || permissions.length < 1 ? false : permissions.find(function (perm) {
    return roles.indexOf(perm.role) !== -1;
  });
};
var _default = exports["default"] = {
  hasAdminRole: hasAdminRole,
  hasRoles: hasRoles
};